import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, } from '@mui/material';
/**
 * Hosts a lesson in a dialog for user to view
 * lesson content from landing page.
 * @returns {React.ReactElement} The lesson dialog component
 */
const LessonDialog = ({ title, open, handleClose, children, }) => {
    return (_jsxs(Dialog, { open: open, onClose: handleClose, sx: {
        // width: '90%',
        // maxWidth: '1200px',
        }, PaperProps: {
            sx: {
                width: '90%',
                maxWidth: '1200px',
                // maxWidth: '80%',
                // height: '90%',
            },
        }, children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: children }), _jsx(DialogActions, { children: _jsx(Button, { variant: "outlined", onClick: handleClose, children: "Ok" }) })] }));
};
export default LessonDialog;
//# sourceMappingURL=LessonDialog.js.map